import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import './style.css'
import Kittens from './views/kittens'
import Queen from './views/queen'
import Home from './views/home'
import ContactUs from './views/contact-us'
import NotFound from './views/not-found'

const App = () => {
  return (
    <Router>
      <Switch>
        <Route component={Kittens} exact path="/kittens" />
        <Route component={Queen} exact path="/queen" />
        <Route component={Home} exact path="/" />
        <Route component={ContactUs} exact path="/contact-us" />
        <Route component={NotFound} path="**" />
        <Redirect to="**" />
      </Switch>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
